module.exports = "<ul class=\"$tabsContainer tabs-container\">\n</ul>\n<ul class=\"$tabsContentContainer tabs-container-container\">\n</ul>\n"